export const userRoles = {
  admin: 'Admin',
  artist: 'Artist',
  consultant: 'Consultant',
  musicTeam: 'Music Team',
  read_only: 'Read Only',
};
